import styled from 'styled-components'

const Card = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }
`

const MapImage = styled.div<{ $imageUrl?: string }>`
  height: 200px;
  background: ${props =>
    props.$imageUrl
      ? `url(${props.$imageUrl}) center/cover`
      : 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 0.9rem;

  @media (max-width: 480px) {
    height: 150px;
  }
`

const CardContent = styled.div`
  padding: 1rem;

  @media (max-width: 480px) {
    padding: 0.75rem;
  }
`

const MapName = styled.h3`
  color: #333;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
  word-wrap: break-word;
  overflow-wrap: break-word;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`

const MapDescription = styled.p`
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 0.75rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

const MapMeta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8rem;
  color: #888;
  flex-wrap: wrap;
  gap: 0.5rem;

  @media (max-width: 480px) {
    font-size: 0.75rem;
  }
`

const MapStatus = styled.span<{ $isPublic: boolean }>`
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  background: ${props => (props.$isPublic ? '#e8f5e8' : '#fff3cd')};
  color: ${props => (props.$isPublic ? '#28a745' : '#856404')};
  font-size: 0.75rem;
  font-weight: 500;
`

export {
  Card,
  MapImage,
  CardContent,
  MapName,
  MapDescription,
  MapMeta,
  MapStatus,
}
